import Vue from 'vue'
import Vuex from 'vuex'
// import * as firebase from 'firebase'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
///import { FirebaseAuth } from '../../../node_modules/@firebase/auth-types';
import ipLocation from 'iplocation'
let NAME = "STORE-USER"
Vue.use(Vuex)

export default{
    state: { 
      user:null, 
      userD: null,
      users:null,
      IP_LOCATION:null,
      IPs:{
        ip1:null,
        ip2:null
      },
      VISITERS:null,
    },
    //___________________-GETTERS-_________________
    getters: { 
      getUser(state) {
        return state.user
      }, 
      getUserByCode(state){
        return code=>{
          if (!code) {return null }
          if (!state.users) {return null}
          return state.users.find(us=>{
            return us.code == code
          })
        }
      },
      getUserByUID(state){
        return uid=>{ 
          if (!uid) {return null }
          if (!state.users) {return null} 
          return state.users.find(us=>{
            return us.key == uid
          })
        }
      },
      getUserD(state) {
        return state.userD
      },
      getUsers(state){
        return state.users
      },
      getIpLocation(state){
        return state.IP_LOCATION
      },
      getIpAddress(state){
        return state.IPs
      },
      getVisiters(state){
        return state.VISITERS
      }, 
    },
    //___________________-MUTATIONS-___________________
    mutations:{  
      updateUser(state, payload) {
        state.user = payload
      }, 
      updateUserD(state, payload) {
        state.userD = payload
      } 
       
    },
    //[____________________[ACTIONS]_____________________]
    actions: { 
      //-------------[SETTER]---------------
      //user
      setUser({ commit,state}, payload) { 
        commit('updateUser', payload)
      }, 
      //user detail
      setUserDetails({ commit,state}, payload) {  
        commit('updateUserD', payload) 
      },

      //---------------[CREATING USER]--------
      fi_createUserWithEmail({ commit}, payload){
        let email = payload.email
        let password = payload.password

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'creating/user'
        })
        firebase.auth().createUserWithEmailAndPassword(email,password)
        .then(result=>{
          //not
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'creating/user'
          })
          commit('updateResponses', {
            res: 'creating/user/successful',
            val: result
          })

        })
        .catch(error=>{
          //not
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'creating/user'
          })
          commit('updateResponses', {
            res: 'creating/user/error',
            val: error
          })
        })
      },

      //---------------[SIGNING USER]---------
      //Number
      fi_signWithPhoneNumber({ commit}, payload){
        let appVerifier = payload.appVerifier
        let phoneNumber = payload.phoneNumber

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'signing/withPhoneNumber'
        })

        firebase.auth().signInWithPhoneNumber(phoneNumber,appVerifier)
        .then(confimationResult=>{

          //not success
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'signing/withPhoneNumber'
          })
          commit('updateResponses', {
            res: 'signing/withPhoneNumber/successful',
            val: confimationResult
          })

        })
        .catch(error=>{
          //not error
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'signing/withPhoneNumber'
          })
          commit('updateResponses', {
            res: 'signing/withPhoneNumber/error',
            val: error
          })
        })
      },
      //confirm
      fi_confirmPhoneNumber({commit},payload){
        let code = payload.code
        let confimationResult = payload.confimationResult

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'signing/confirmPhoneNumber'
        })
        confimationResult.confirm(code)
        .then(result=>{
          //not successs
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'signing/confirmPhoneNumber'
          })
          commit('updateResponses', {
            res: 'signing/confirmPhoneNumber/successful',
            val: result
          })
        })
        .catch(error=>{
          //not error
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'signing/confirmPhoneNumber'
          })
          commit('updateResponses', {
            res: 'signing/confirmPhoneNumber/error',
            val: error
          })
        })
      },
      //Number
      fi_signWithEmail({ commit}, payload){ 
        let email = payload.email
        let password = payload.password
        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          add: true,
          name: 'signing/withEmail'
        })
        firebase.auth().signInWithEmailAndPassword(email,password)
        .then(res=>{
          //not
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'signing/withEmail'
          })
          commit('updateResponses', {
            res: 'signing/withEmail/successful',
            val: res
          }) 
        })
        .catch(err=>{
          //not
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'signing/withEmail'
          })
          commit('updateResponses', {
            res: 'signing/withEmail/error',
            val: err
          }) 
        })
 
      }, 
      //Gmail
      fi_signWithGmail({commit},payload) {
        //remember
        let GML = JSON.parse(localStorage.getItem('GML'));
        let date = new Date
        let detail = {
          date: date.toISOString(),
          gmail: true
        }
        if (GML === null) {
          localStorage.setItem('GML', JSON.stringify(detail));
        } else {
          localStorage.removeItem('GML')
          localStorage.setItem('GML', JSON.stringify(detail));
        }
        //
        var provider = new firebase.auth.GoogleAuthProvider()
        
        // provider.addScope('profile');
        // provider.addScope('https://www.googleapis.com/auth/userinfo.profile');
        // provider.addScope('https://www.googleapis.com/auth/userinfo.email');
        // provider.addScope('https://www.googleapis.com/auth/plus.login');
        // provider.addScope('https://www.googleapis.com/auth/plus.me');
        // provider.addScope('https://www.googleapis.com/auth/user.birthday.read');
        // provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
        // provider.addScope('email');
        
        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'signing/withGmail'
        })
        firebase.auth().signInWithRedirect(provider)
        //firebase.auth().signInWithPopup(provider)
          .then(function (result) {
             //not
             commit('updateLoading', false)
             commit('updateProcesses', {
               action: 'remove',
               value: 'signing/withGmail'
             })
             commit('updateResponses', {
               res: 'signing/withGmail/successful',
               val: result
             })
            if (result.credential) {
              // This gives you a Google Access Token. You can use it to access the Google API.
              var token = result.credential.accessToken;
              // ...
            }
            // The signed-in user info.
            var user = result.user;
            console.log(result, 'ddd');
          }).catch(function (error) {
            //not
            commit('updateLoading', false)
            commit('updateProcesses', {
              action: 'remove',
              value: 'signing/withGmail'
            })
            commit('updateResponses', {
              res: 'signing/withGmail/error',
              val: error
            })
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // The email of the user's account used.
            var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            var credential = error.credential;
            // ...
            console.log(error, 'eeeeeee');
          });

      } ,
      fi_getGoogleResults(){
        firebase.auth().getRedirectResult().then(function (result) {
          if (result.credential) {
            // This gives you a Google Access Token. You can use it to access the Google API.
            var token = result.credential.accessToken;
            // ...
          }
          // The signed-in user info.
          var user = result.user;
          console.log(result, 'goooooooooooooo');
          
        }).catch(function (error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          // ...
          console.log(error,'err, googleeeeeeeeeeeeeeee');
          
        });
      },
      //Facebook
      fi_signWithFacebook() {
        //var provider = new firebase.auth.GoogleAuthProvider()
        var provider = new firebase.auth.FacebookAuthProvider()

        // provider.addScope('profile');
        // provider.addScope('https://www.googleapis.com/auth/userinfo.profile');
        // provider.addScope('https://www.googleapis.com/auth/userinfo.email');
        // provider.addScope('https://www.googleapis.com/auth/plus.login');
        // provider.addScope('https://www.googleapis.com/auth/plus.me');
        // provider.addScope('https://www.googleapis.com/auth/user.birthday.read');
        // provider.addScope('https://www.googleapis.com/auth/contacts.readonly')
        // provider.addScope('email');

        // firebase.auth().signInWithPopup(provider)
        firebase.auth().signInWithRedirect(provider)
          .then(function (result) {
            if (result.credential) {
              // This gives you a Google Access Token. You can use it to access the Google API.
              var token = result.credential.accessToken;
              // ...
            }
            // The signed-in user info.
            var user = result.user;
            console.log(result, 'ddd');
          }).catch(function (error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // The email of the user's account used.
            var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            var credential = error.credential;
            // ...
            console.log(error, 'eeeeeee');
          });

      },
      //Twitter
      fi_signWithTwitter() { 
        var provider = new firebase.auth.TwitterAuthProvider()
        // firebase.auth().signInWithPopup(provider)
        firebase.auth().signInWithRedirect(provider)
          .then(function (result) {
            if (result.credential) {
              // This gives you a Google Access Token. You can use it to access the Google API.
              var token = result.credential.accessToken;
              // ...
            }
            // The signed-in user info.
            var user = result.user;
            console.log(result, 'ddd');
          }).catch(function (error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // The email of the user's account used.
            var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            var credential = error.credential;
            // ...
            console.log(error, 'eeeeeee');
          });

      },
      //--------------[Recaptach]--------
      fi_createRecaptach(){

      },

      //--------------[SIGN OUT USER]--------
      fi_signUserOut({ commit, state }, payload) { 
        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'signing/out'
        })
        firebase.auth().signOut()
        .then(result=>{ 
          state.user = null
          state.userD = null
          //not
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'signing/out'
          })
          commit('updateResponses', {
            res: 'signing/out/successful',
            val: result
          })
        }).catch(error=>{
          //not
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'signing/out'
          })
          commit('updateResponses', {
            res: 'signing/out/error',
            val: error
          })
        });
      },

      //---------[SEND VERIFICATION 2 USER]--------
      //send verification email
      fi_sendVerificationEmail({ commit, state }, payload){
        let user = state.user

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'sending/verificationEmail'
        })
        user.sendEmailVerification()
        .then(result=>{
          //not success
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'sending/verificationEmail'
          })
          commit('updateResponses', {
            res: 'sending/verificationEmail/successful',
            val: result
          })
        })
        .catch(error=>{
          //not success
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'sending/verificationEmail'
          })
          commit('updateResponses', {
            res: 'sending/verificationEmail/error',
            val: error
          })
        })
      },
      //send password rest email
      fi_sendPasswordResetEmail({ commit, state }, payload){
        let email = payload.email
        let auth = firebase.auth()

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'sending/resetEmail'
        })
        auth.sendPasswordResetEmail(email)
        .then(result=>{
          //not success
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'sending/resetEmail'
          })
          commit('updateResponses', {
            res: 'sending/resetEmail/successful',
            val: result
          })
        })
        .catch(error=>{
          //not success
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'sending/resetEmail'
          })
          commit('updateResponses', {
            res: 'sending/resetEmail/error',
            val: error
          })
        })
      },

      //---------------[UPDATE USER / CODE]--------
      //profile
      fi_updateUserProfile({commit,state},payload){
        let user = state.user
        let detail = payload.detail
        let firstName = detail.firstName
        let lastName = detail.lastName

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'updating/userProfile'
        })
        user.updateProfile({
          displayName:firstName+' '+lastName
        })
        .then(()=>{
          return firebase.database().ref('Users/' + user.uid)
          .update(detail)
        })
        .then(result=>{
          //not success
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'updating/userProfile'
          })
          commit('updateResponses', {
            res: 'updating/userProfile/successful',
            val: result
          })
        })
        .catch(error=>{
          //not error
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'updating/userProfile'
          })
          commit('updateResponses', {
            res: 'updating/userProfile/error',
            val: error
          })
        })
      },
      fi_updateBusinessUserProfile({ commit, state }, payload) {
        let user = state.user
        let detail = payload.detail
        let businessName = detail.businessName

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'updating/userProfile'
        })
        user.updateProfile({
          displayName: businessName
        })
          .then(() => {
            return firebase.database().ref('Users/' + user.uid)
              .update(detail)
          })
          .then(result => {
            //not success
            commit('updateLoading', false)
            commit('updateProcesses', {
              action: 'remove',
              value: 'updating/userProfile'
            })
            commit('updateResponses', {
              res: 'updating/userProfile/successful',
              val: result
            })
          })
          .catch(error => {
            //not error
            commit('updateLoading', false)
            commit('updateProcesses', {
              action: 'remove',
              value: 'updating/userProfile'
            })
            commit('updateResponses', {
              res: 'updating/userProfile/error',
              val: error
            })
          })
      },
      //profile pic
      fi_updateUserProfilePicture({commit,state},payload){
        // create image from base64
        function dataURItoBlob(dataURI) {
          // convert base64/URLEncoded data component to raw binary data held in a string
          var byteString;

          if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
          else
            byteString = unescape(dataURI.split(',')[1]);

          // separate out the mime component
          var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

          // write the bytes of the string to a typed array
          var ia = new Uint8Array(byteString.length);
          for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }

          return new Blob([ia], { type: mimeString });
        } 
        let newImage = dataURItoBlob(payload);
        let uid = state.user.uid
        let ext = 'jpeg'
        let storeRef = firebase.storage().ref()
        let uploadTask = null
        let pNum =0
        let photoURL=''

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'update',
          value: 'uploading/profilePicture',
          number: 1
        })
        if (uid!=null) {
          // Create the file metadata
          let metadata={
            contentType:'image/'+ext
          }
          //upload image and metadata extetion  
          uploadTask = storeRef.child('UPI/'+uid+"."+ext).put(newImage,metadata)

          // Listen for state changes, errors, and completion of the upload.
          uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,snapshot=>{
            //TASK PROGRESS, INCLUDING THE NUMBER OF BYTES UPLOADED
            let progress = (snapshot.bytesTransferred / snapshot.totalBytes)*100
            pNum= 0 + progress
            console.log('Upload is ' + pNum + '% done') 
            
            commit('updateProcesses', {
              action: 'update',
              value: 'uploading/profilePicture',
              number: pNum
            })  
            switch(snapshot.state){
              case firebase.storage.TaskState.PAUSED:  // or 'paused'
                commit('updateResponses', {
                  res: 'uploading/profilePicture/state',
                  val: 'paused'
                })
                console.log("Upload is paused")
                break
              case firebase.storage.TaskState.RUNNING: // or 'running'
                commit('updateResponses', {
                  res: 'uploading/profilePicture/state',
                  val: 'running'
                })
                //console.log('Upload is running');
                break; 
            }

          },error=>{
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            commit('updateLoading', false)
            commit('updateProcesses', {
              action: 'remove/update',
              value: 'uploading/profilePicture' 
            })
            commit('updateResponses', {
              res: 'uploading/profilePicture/error',
              val: error
            })
            switch (error.code) {
              case 'storage/unauthorized':
                // User doesn't have permission to access the object 
                break 
              case 'storage/canceled':
                // User canceled the upload 
                break 
              case 'storage/unknown':
                // Unknown error occurred, inspect error.serverResponse 
                break;
            }
          },()=>{
            // Upload completed successfully, now we can get the download URL 
            uploadTask.snapshot.ref.getDownloadURL() 
            .then(function (downloadURL) { 
              photoURL = downloadURL
              return state.user.updateProfile({ photoURL: photoURL})
            })
            .then(res=>{
              return firebase.database().ref('Users/' +uid).update(
                { photoURL: photoURL }
              )
            })
            .then(data=>{
              commit('updateLoading', false)
              commit('updateProcesses', {
                action: 'remove/update',
                value: 'uploading/profilePicture'
              })
              commit('updateResponses', {
                res: 'uploading/profilePicture/success',
                val: data
              })
            }).catch(error=>{
              commit('updateLoading', false)
              commit('updateProcesses', {
                action: 'remove/update',
                value: 'uploading/profilePicture'
              })
              commit('updateResponses', {
                res: 'uploading/profilePicture/error',
                val: error
              })
            })
          }) 
        }else{
          console.log('Unable to upload image') 
          commit('updateLoading', false) 
          commit('updateProcesses', {
            action: 'remove/update',
            value: 'uploading/profilePicture' 
          })
          commit('updateResponses', {
            res: 'uploading/profilePicture/error',
            val: 'no user'
          })
        }
      }, 
      //detail
      fi_updateUserDetails({ commit, state }, payload) {
        let user = state.user
        let detail = payload.detail

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'updating/userDetails'
        })
        firebase.database().ref('Users/' + user.uid).update(detail)
          .then(result => {
            //not success
            commit('updateLoading', false)
            commit('updateProcesses', {
              action: 'remove',
              value: 'updating/userDetails'
            })
            commit('updateResponses', {
              res: 'updating/userDetails/successful',
              val: result
            })
          }).catch(error => { 
            //not success
            commit('updateLoading', false)
            commit('updateProcesses', {
              action: 'remove',
              value: 'updating/userDetails'
            })
            commit('updateResponses', {
              res: 'updating/userDetails/error',
              val: error
            })
          })

      }, 
      //account 
      fi_updateUsersAccounts({ commit, state }, payload) {
        let uid = payload.uid
        let detail = payload.detail 
        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'updating/updateUsersAccounts'
        })
        firebase.database().ref('Users/' + uid).update(detail)
          .then(result => {
            //not success
            commit('updateLoading', false)
            commit('updateProcesses', {
              action: 'remove',
              value: 'updating/updateUsersAccounts'
            })
            commit('updateResponses', {
              res: 'updating/updateUsersAccounts/successful',
              val: result
            }) 
            
          }).catch(error => { 
            //not success
            commit('updateLoading', false)
            commit('updateProcesses', {
              action: 'remove',
              value: 'updating/updateUsersAccounts'
            })
            commit('updateResponses', {
              res: 'updating/updateUsersAccounts/error',
              val: error
            })
          })

      },
      //account 
      fi_updateCode({ commit, state }, payload) {
        let code = payload.code
        let detail = payload.detail
        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'updating/updateCode'
        })
        firebase.database().ref('ActivationCodes/' + code).update(detail)
          .then(result => {
            //not success
            commit('updateLoading', false)
            commit('updateProcesses', {
              action: 'remove',
              value: 'updating/updateCode'
            })
            commit('updateResponses', {
              res: 'updating/updateCode/successful',
              val: result
            })

          }).catch(error => {
            //not success
            commit('updateLoading', false)
            commit('updateProcesses', {
              action: 'remove',
              value: 'updating/updateCode'
            })
            commit('updateResponses', {
              res: 'updating/updateCode/error',
              val: error
            })
          })

      },
      //email 
      fi_updateUserEmail({commit,state},payload){
        let user = state.user
        let email = payload.email 

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'updating/userEmail'
        })
        user.updateEmail(email) 
        .then(result=>{
          //not success
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'updating/userEmail'
          })
          commit('updateResponses', {
            res: 'updating/userEmail/successful',
            val: result
          })
        })
        .catch(error=>{
          //not error
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'updating/userEmail'
          })
          commit('updateResponses', {
            res: 'updating/userEmail/error',
            val: error
          })
        })
      },
      //password
      fi_updateUserPassword({commit,state},payload){
        let user = state.user 
        let password = payload.password

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'updating/userPassword'
        })
        user.updatePassword(password)
        .then(result=>{
          //not success
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'updating/userPassword'
          })
          commit('updateResponses', {
            res: 'updating/userPassword/successful',
            val: result
          })
        })
        .catch(error=>{
          //not error
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'updating/userPassword'
          })
          commit('updateResponses', {
            res: 'updating/userPassword/error',
            val: error
          })
        })
      },
      //email and password
      fi_updateUserEmailAndPassword({commit,state},payload){
        let user = state.user
        let email = payload.email
        let password = payload.password

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'updating/userEmailAndPassword'
        })
        user.updateEmail(email)
        .then(()=>{
          return user.updatePassword(password)
        })
        .then(result=>{
          //not success
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'updating/userEmailAndPassword'
          })
          commit('updateResponses', {
            res: 'updating/userEmailAndPassword/successful',
            val: result
          })
        })
        .catch(error=>{
          //not error
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'updating/userEmailAndPassword'
          })
          commit('updateResponses', {
            res: 'updating/userEmailAndPassword/error',
            val: error
          })
        })
      },

      //----------------[DELETE]----------
      //user
      fi_deleteUser({ commit,dispatch, state }, payload){ 
        let user = firebase.auth().currentUser

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'deleting/user'
        })
        user.delete()
        .then(result=>{
          //not success
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'deleting/user'
          })
          commit('updateResponses', {
            res: 'deleting/user/successful',
            val: result
          })
          dispatch('fi_signOut')
        })
        .catch(error=>{
          //not success
          commit('updateLoading', false)
          commit('updateProcesses', {
            action: 'remove',
            value: 'deleting/user'
          })
          commit('updateResponses', {
            res: 'deleting/user/error',
            val: error
          })
        })
      },
      fi_deleteUserProfilePicture({commit,state},payload){ 
        let uid = state.user.uid
        let ext = 'jpeg'
        let storeRef = firebase.storage().ref() 

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          action: 'add',
          value: 'deleting/profilePicture' 
        })
        if (uid!=null) {   
          storeRef.child('UPI/'+uid+"."+ext).delete() 
          .then( ()=> { 
            return state.user.updateProfile({
              photoURL: null
            })
          })
          .then(res => {
            return firebase.database().ref('Users/' + uid).update({
              photoURL: null
            })
          })
          .then(data => {
            commit('updateLoading', false)
            commit('updateProcesses', {
              action: 'remove',
              value: 'deleting/profilePicture'
            })
            commit('updateResponses', {
              res: 'deleting/profilePicture/success',
              val: data
            })
          }).catch(error => {
            commit('updateLoading', false)
            commit('updateProcesses', {
              action: 'remove',
              value: 'deleting/profilePicture'
            })
            commit('updateResponses', {
              res: 'deleting/profilePicture/error',
              val: error
            })
          })
           
 
        }else{
          console.log('Unable to upload image') 
          commit('updateLoading', false) 
          commit('updateProcesses', {
            action: 'remove/update',
            value: 'uploading/profilePicture' 
          })
          commit('updateResponses', {
            res: 'uploading/profilePicture/error',
            val: 'no user'
          })
        }
      }, 
      //----------------[ACTIVATE]--------------
      fi_activateUser({commit,dispatch,state},payload){
        let date = new Date()
        let user = payload.us
        let code = payload.code
        let usType = payload.type
        let codeRef = firebase.database().ref('ActivationCodes/'+code+'/')
        let userRef = firebase.database().ref('Users/'+user.uid+"/activation/")

        codeRef.once('value').then(snapshot=>{ 
          //check code
          commit('updateLoading', true)
          commit('updateProcesses', {
            action: 'add',
            value: 'activating/user'
          })
          let cd  = snapshot.val()
          if (!cd) {
            //Code not exist
            commit('updateLoading', false)
            commit('updateProcesses', {
              action: 'remove',
              value: 'activating/user'
            })
            commit('updateResponses', {
              res: 'activating/user/error',
              val: 'not exist'
            }) 
          } else {
            let used = cd.used
            let active = cd.active
            let type = cd.type
            //check type
            if (type !== usType) { 
              commit('updateLoading', false)
              commit('updateProcesses', {
                action: 'remove',
                value: 'activating/user'
              })
              commit('updateResponses', {
                res: 'activating/user/error',
                val: 'not type'
              }) 
            } else {
              //check used
              if (used) { 
                commit('updateLoading', false)
                commit('updateProcesses', {
                  action: 'remove',
                  value: 'activating/user'
                })
                commit('updateResponses', {
                  res: 'activating/user/error',
                  val: 'used'
                }) 
              } else {
                //check active 
                if (!active) {
                  //Code not exist
                  commit('updateLoading', false)
                  commit('updateProcesses', {
                    action: 'remove',
                    value: 'activating/user'
                  })
                  commit('updateResponses', {
                    res: 'activating/user/error',
                    val: 'not active'
                  }) 
                } else {
                  //-------[UPDATE CODE]-------
                  codeRef.update({
                    usedBy:user.uid,
                    used:true
                  }).then(result=>{ 
                    return userRef.update({code:code,date:date.toISOString()})
                  }).then(result=>{
                    //success
                    commit('updateLoading', false)
                    commit('updateProcesses', {
                      action: 'remove',
                      value: 'activating/user'
                    })
                    commit('updateResponses', {
                      res: 'activating/user/successful',
                      val: result
                    })
                  }).catch(err=>{
                    //Code not exist
                    commit('updateLoading', false)
                    commit('updateProcesses', {
                      action: 'remove',
                      value: 'activating/user'
                    })
                    commit('updateResponses', {
                      res: 'activating/user/error',
                      val: err
                    }) 
                  }) 
                }

              }
            }
          }
           
          
        })
      },

      //---------------[FIRE ADD]-----------
    //visiter
      fi_add_visiter({ commit, state }, payload){
        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          add: true,
          name: 'adding/visiter'
        })
        let date = new Date
        let data = payload.data

        //GET USER IP ADDRESS 
        let http = this._vm.$http
        http.get("https://httpbin.org/ip")
        .then(res=>{
          let ips = res.body.origin 
          if (ips.includes(",")) {
            let ip1 = ips.split(",")[0]
            let ip2 = ips.split(",")[1]
            state.IPs.ip1 = ip1
            state.IPs.ip2 = ip2 
          } else {
            state.IPs.ip1 = ips
          } 
          return state.IPs
        },error=>{
          commit("ERROR",{
            page:NAME,
            from:"fi_add_visiter",
            error:error
          })
          return "0.0.0.0"
        }).then(ips=>{
          return ipLocation(ips.ip1)
        }).then(res=>{
          state.IP_LOCATION = res 

          //------ADD VISITER
          let TERESIAN_VISITER = JSON.parse(localStorage.getItem('TERESIAN_VISITER')) 
          if (TERESIAN_VISITER===null) {    
            let visiter ={
              ...data,
              date: date.toISOString()
            } 
            let visiterKey = null
            firebase.database().ref('TERESIAN/SETTINGS/VISITERS/').push(visiter)
            .then(data=>{
              // Data saved successfully!
              visiterKey = data.key
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'adding/visiter'
              })
              commit('updateResponses', {
                res: 'adding/visiter/successful',
                val: data
              })
              let vst={
                date: date.toISOString(),
                key:data.key
              }  
              return localStorage.setItem('TERESIAN_VISITER', JSON.stringify(vst)) 
            })
            .then(data=>{ 
              return state.IP_LOCATION
            })
            .then(res=>{ 
              return firebase.database().ref('TERESIAN/SETTINGS/VISITERS/' + visiterKey + '/location').set(res)
            }) 
            .then(res=>{ 
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'adding/visiter'
              })
              commit('updateResponses', {
                res: 'adding/visiter/successful',
                val: res
              })
            })
            .catch(error=>{
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'adding/visiter'
              })
              commit('updateResponses', {
                res: 'adding/visiter/error',
                val: error
              })
              commit("ERROR",{
                page:NAME,
                from:"fi_deleteUser",
                error:error
              })
            })
            
          }else{
            let vst = { 
              date: date.toISOString()
            }
            firebase.database().ref('TERESIAN/SETTINGS/VISITERS/'+TERESIAN_VISITER.key+'/revisit').push(vst)
              .then(data => {
                commit('updateLoading', false)
                commit('updateProcesses', { 
                  name: 'adding/visiter'
                })
                commit('updateResponses', {
                  res: 'adding/visiter/successful',
                  val: data
                })
              }).catch(error => {
                commit('updateLoading', false)
                commit('updateProcesses', {
                  action: 'remove',
                  value: 'adding/visiter'
                })
                commit('updateResponses', {
                  res: 'adding/visiter/error',
                  val: error
                })
                commit("ERROR",{
                  page:NAME,
                  from:"fi_add_visiter",
                  error:error
                })
              })
            
          }
        }).catch(error => {
          commit("ERROR",{
            page:NAME,
            from:"fi_add_visiter",
            error:error
          })
        }) 
        
      },
      fi_getOn_Visiters({ commit, state }) {
        commit('updateProcesses', {
          add: true,
          name: 'getting/Visiters'
        })
        let ref = firebase.database().ref('TERESIAN/SETTINGS/VISITERS/')
        ref.on('value', data => {
          commit('updateProcesses', { 
            name: 'getting/Visiters'
          })
          let obj = data.val()
          let newData = []
          let i = 1
          for (const key in obj) {
            let sms = obj[key]
            newData.push({
              i:i,
              key: key,
              ...sms
            })
            i++
          }
          state.VISITERS = newData
  
        })
      },   
    },
}
